import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { INotesTypeEntityDTO, UpdateNotesTypeDto } from '@modeso/types__aumico-lib-notes-be';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import Debug from 'debug';
import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import * as fromActions from '../actions/notesTypes.actions';
import { AumicoNotesService } from '../services/notes.service';

const debug = Debug('aumico:aumico-lib-notes-fe:NotesTypesEffects');

@Injectable()
export class NotesTypesEffects {
    constructor(private actions$: Actions, private service: AumicoNotesService) {}

    getNotesTypes$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.getNotesTypes.type),
            mergeMap(() => {
                return this.service.getNotesTypes().pipe(
                    map((response: INotesTypeEntityDTO[]) => {
                        debug(response);
                        return fromActions.onGetNotesTypesSuccessfully({ payload: response });
                    }),
                    catchError((error: HttpErrorResponse) => {
                        return of(fromActions.onGetNotesTypesFailed({ payload: error }));
                    }),
                );
            }),
        ),
    );

    createNotesType$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.createNotesType.type),
            mergeMap((action: fromActions.ActionWithPayload<INotesTypeEntityDTO>) => {
                return this.service.createNotesType(action).pipe(
                    map((response: INotesTypeEntityDTO) => {
                        debug(response);
                        return fromActions.onCreateNotesTypeSuccessfully({ payload: response });
                    }),
                    catchError((error: HttpErrorResponse) => {
                        return of(fromActions.onCreateNotesTypeFailed({ payload: error }));
                    }),
                );
            }),
        ),
    );

    updateNotesType$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.updateNotesType.type),
            mergeMap((action: fromActions.ActionWithPayload<UpdateNotesTypeDto>) => {
                return this.service.updateNotesType(action).pipe(
                    map(() => {
                        debug(action.payload);
                        return fromActions.onUpdateNotesTypeSuccessfully({ payload: action.payload });
                    }),
                    catchError((error: HttpErrorResponse) => {
                        return of(fromActions.onUpdateNotesTypeFailed({ payload: error }));
                    }),
                );
            }),
        ),
    );

    errorOnNotesTypes$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(
                    fromActions.onCreateNotesTypeFailed.type,
                    fromActions.onGetNotesTypesFailed.type,
                    fromActions.onUpdateNotesTypeFailed.type,
                ),
                tap((action: fromActions.ActionWithPayload<HttpErrorResponse>) =>
                    this.handleOnLoadAllErrors(action.payload),
                ),
            ),
        { dispatch: false },
    );

    getAllNotesTypesNamesAndIds$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fromActions.getAllNotesTypesNamesAndIds.getAllNotesTypesNamesAndIds.type),
            mergeMap(() => {
                return this.service.getNotesTypesNamesAndIds().pipe(
                    map((response) => {
                        return fromActions.getAllNotesTypesNamesAndIds.getAllNotesTypesNamesAndIdsSuccess({
                            payload: response,
                        });
                    }),
                    catchError((error: HttpErrorResponse) => {
                        return of(
                            fromActions.getAllNotesTypesNamesAndIds.getAllNotesTypesNamesAndIdsFailed({
                                payload: error,
                            }),
                        );
                    }),
                );
            }),
        ),
    );

    handleOnLoadAllErrors(error) {
        debug('handleOnLoadAllErrors');
        debug(error);
        return error;
    }
}
